import { render, staticRenderFns } from "./Booster.vue?vue&type=template&id=8c1169aa&"
import script from "./Booster.vue?vue&type=script&lang=js&"
export * from "./Booster.vue?vue&type=script&lang=js&"
import style0 from "./Booster.vue?vue&type=style&index=0&id=8c1169aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports